import { useEffect, useState } from "react";
import "./AgeVerificationModal.css";
import logo from "../../assets/images/visuals/logo_apocalypse_lovers.png";

const AGE_VERIFICATION_KEY = "apocalypse_lovers_age_verified";

function AgeVerificationModal() {
  const [isVisible, setIsVisible] = useState(() => {
    try {
      return localStorage.getItem(AGE_VERIFICATION_KEY) !== "true";
    } catch {
      return true;
    }
  });

  useEffect(() => {
    if (!isVisible) {
      return undefined;
    }

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [isVisible]);

  const handleEnter = () => {
    try {
      localStorage.setItem(AGE_VERIFICATION_KEY, "true");
    } catch {
      // If storage is unavailable, allow entry after explicit confirmation.
    }

    setIsVisible(false);
  };

  const handleExit = () => {
    window.location.assign("https://www.google.com");
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="age-verification-overlay" role="presentation">
      <div
        className="age-verification-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="age-verification-title"
        aria-describedby="age-verification-description"
      >
        <div className="age-verification-brand">
          <img src={logo} alt="Apocalypse Lovers" />
        </div>
        <p className="age-verification-kicker">Adults only</p>
        <h2 id="age-verification-title">Age Verification Required</h2>
        <p id="age-verification-description">
          Apocalypse Lovers contains adult-oriented fictional, illustrated, and
          computer-generated material. You must be at least 18 years old, or the
          legal age of majority in your jurisdiction, whichever is higher, to
          enter.
        </p>
        <ul className="age-verification-list">
          <li>All characters featured on this website are fictional and over 18 years old.</li>
          <li>No real performers or real-person intimate imagery are used.</li>
          <li>By entering, you confirm you may legally view adult content.</li>
        </ul>
        <div className="age-verification-actions">
          <button type="button" className="age-enter-btn" onClick={handleEnter}>
            I am 18 or older
          </button>
          <button type="button" className="age-exit-btn" onClick={handleExit}>
            I am under 18
          </button>
        </div>
      </div>
    </div>
  );
}

export default AgeVerificationModal;
